/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as AppAdminRouteImport } from './routes/_app.admin'
import { Route as AppAuditRouteImport } from './routes/_app.audit'
import { Route as AppGoogleAdsRouteImport } from './routes/_app.google-ads'
import { Route as AppGoogleAdsResultsRouteImport } from './routes/_app.google-ads-results'
import { Route as AppRepeatBuyersRouteImport } from './routes/_app.repeat-buyers'
import { Route as AppSalesRouteImport } from './routes/_app.sales'
import { Route as AppSearchConsoleRouteImport } from './routes/_app.search-console'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AppTermsRouteImport } from './routes/_app.terms'
import { Route as AppWebsiteRouteImport } from './routes/_app.website'
import { Route as AppMetaIndexRouteImport } from './routes/_app.meta.index'
import { Route as AppMetaAdsRouteImport } from './routes/_app.meta.ads'
import { Route as AppMetaAudiencesRouteImport } from './routes/_app.meta.audiences'
import { Route as AppMetaCampaignsRouteImport } from './routes/_app.meta.campaigns'
import { Route as AppProductsIndexRouteImport } from './routes/_app.products.index'
import { Route as AppProductsIdRouteImport } from './routes/_app.products.$id'
import { Route as AppShoppersIndexRouteImport } from './routes/_app.shoppers.index'
import { Route as AppShoppersVisitorsRouteImport } from './routes/_app.shoppers.visitors'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditRoute = AppAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppRoute,
} as any)
const AppGoogleAdsRoute = AppGoogleAdsRouteImport.update({
  id: '/google-ads',
  path: '/google-ads',
  getParentRoute: () => AppRoute,
} as any)
const AppGoogleAdsResultsRoute = AppGoogleAdsResultsRouteImport.update({
  id: '/google-ads-results',
  path: '/google-ads-results',
  getParentRoute: () => AppRoute,
} as any)
const AppRepeatBuyersRoute = AppRepeatBuyersRouteImport.update({
  id: '/repeat-buyers',
  path: '/repeat-buyers',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesRoute = AppSalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => AppRoute,
} as any)
const AppSearchConsoleRoute = AppSearchConsoleRouteImport.update({
  id: '/search-console',
  path: '/search-console',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppTermsRoute = AppTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => AppRoute,
} as any)
const AppWebsiteRoute = AppWebsiteRouteImport.update({
  id: '/website',
  path: '/website',
  getParentRoute: () => AppRoute,
} as any)
const AppMetaIndexRoute = AppMetaIndexRouteImport.update({
  id: '/meta/',
  path: '/meta/',
  getParentRoute: () => AppRoute,
} as any)
const AppMetaAdsRoute = AppMetaAdsRouteImport.update({
  id: '/meta/ads',
  path: '/meta/ads',
  getParentRoute: () => AppRoute,
} as any)
const AppMetaAudiencesRoute = AppMetaAudiencesRouteImport.update({
  id: '/meta/audiences',
  path: '/meta/audiences',
  getParentRoute: () => AppRoute,
} as any)
const AppMetaCampaignsRoute = AppMetaCampaignsRouteImport.update({
  id: '/meta/campaigns',
  path: '/meta/campaigns',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsIndexRoute = AppProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsIdRoute = AppProductsIdRouteImport.update({
  id: '/products/$id',
  path: '/products/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppShoppersIndexRoute = AppShoppersIndexRouteImport.update({
  id: '/shoppers/',
  path: '/shoppers/',
  getParentRoute: () => AppRoute,
} as any)
const AppShoppersVisitorsRoute = AppShoppersVisitorsRouteImport.update({
  id: '/shoppers/visitors',
  path: '/shoppers/visitors',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/admin': typeof AppAdminRoute
  '/audit': typeof AppAuditRoute
  '/google-ads': typeof AppGoogleAdsRoute
  '/google-ads-results': typeof AppGoogleAdsResultsRoute
  '/repeat-buyers': typeof AppRepeatBuyersRoute
  '/sales': typeof AppSalesRoute
  '/search-console': typeof AppSearchConsoleRoute
  '/settings': typeof AppSettingsRoute
  '/terms': typeof AppTermsRoute
  '/website': typeof AppWebsiteRoute
  '/meta/ads': typeof AppMetaAdsRoute
  '/meta/audiences': typeof AppMetaAudiencesRoute
  '/meta/campaigns': typeof AppMetaCampaignsRoute
  '/products/$id': typeof AppProductsIdRoute
  '/shoppers/visitors': typeof AppShoppersVisitorsRoute
  '/meta/': typeof AppMetaIndexRoute
  '/products/': typeof AppProductsIndexRoute
  '/shoppers/': typeof AppShoppersIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/admin': typeof AppAdminRoute
  '/audit': typeof AppAuditRoute
  '/google-ads': typeof AppGoogleAdsRoute
  '/google-ads-results': typeof AppGoogleAdsResultsRoute
  '/repeat-buyers': typeof AppRepeatBuyersRoute
  '/sales': typeof AppSalesRoute
  '/search-console': typeof AppSearchConsoleRoute
  '/settings': typeof AppSettingsRoute
  '/terms': typeof AppTermsRoute
  '/website': typeof AppWebsiteRoute
  '/': typeof AppIndexRoute
  '/meta/ads': typeof AppMetaAdsRoute
  '/meta/audiences': typeof AppMetaAudiencesRoute
  '/meta/campaigns': typeof AppMetaCampaignsRoute
  '/products/$id': typeof AppProductsIdRoute
  '/shoppers/visitors': typeof AppShoppersVisitorsRoute
  '/meta': typeof AppMetaIndexRoute
  '/products': typeof AppProductsIndexRoute
  '/shoppers': typeof AppShoppersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_app/admin': typeof AppAdminRoute
  '/_app/audit': typeof AppAuditRoute
  '/_app/google-ads': typeof AppGoogleAdsRoute
  '/_app/google-ads-results': typeof AppGoogleAdsResultsRoute
  '/_app/repeat-buyers': typeof AppRepeatBuyersRoute
  '/_app/sales': typeof AppSalesRoute
  '/_app/search-console': typeof AppSearchConsoleRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/terms': typeof AppTermsRoute
  '/_app/website': typeof AppWebsiteRoute
  '/_app/': typeof AppIndexRoute
  '/_app/meta/ads': typeof AppMetaAdsRoute
  '/_app/meta/audiences': typeof AppMetaAudiencesRoute
  '/_app/meta/campaigns': typeof AppMetaCampaignsRoute
  '/_app/products/$id': typeof AppProductsIdRoute
  '/_app/shoppers/visitors': typeof AppShoppersVisitorsRoute
  '/_app/meta/': typeof AppMetaIndexRoute
  '/_app/products/': typeof AppProductsIndexRoute
  '/_app/shoppers/': typeof AppShoppersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/reset-password'
    | '/admin'
    | '/audit'
    | '/google-ads'
    | '/google-ads-results'
    | '/repeat-buyers'
    | '/sales'
    | '/search-console'
    | '/settings'
    | '/terms'
    | '/website'
    | '/meta/ads'
    | '/meta/audiences'
    | '/meta/campaigns'
    | '/products/$id'
    | '/shoppers/visitors'
    | '/meta/'
    | '/products/'
    | '/shoppers/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/reset-password'
    | '/admin'
    | '/audit'
    | '/google-ads'
    | '/google-ads-results'
    | '/repeat-buyers'
    | '/sales'
    | '/search-console'
    | '/settings'
    | '/terms'
    | '/website'
    | '/'
    | '/meta/ads'
    | '/meta/audiences'
    | '/meta/campaigns'
    | '/products/$id'
    | '/shoppers/visitors'
    | '/meta'
    | '/products'
    | '/shoppers'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/reset-password'
    | '/_app/admin'
    | '/_app/audit'
    | '/_app/google-ads'
    | '/_app/google-ads-results'
    | '/_app/repeat-buyers'
    | '/_app/sales'
    | '/_app/search-console'
    | '/_app/settings'
    | '/_app/terms'
    | '/_app/website'
    | '/_app/'
    | '/_app/meta/ads'
    | '/_app/meta/audiences'
    | '/_app/meta/campaigns'
    | '/_app/products/$id'
    | '/_app/shoppers/visitors'
    | '/_app/meta/'
    | '/_app/products/'
    | '/_app/shoppers/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audit': {
      id: '/_app/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AppAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/google-ads': {
      id: '/_app/google-ads'
      path: '/google-ads'
      fullPath: '/google-ads'
      preLoaderRoute: typeof AppGoogleAdsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/google-ads-results': {
      id: '/_app/google-ads-results'
      path: '/google-ads-results'
      fullPath: '/google-ads-results'
      preLoaderRoute: typeof AppGoogleAdsResultsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/repeat-buyers': {
      id: '/_app/repeat-buyers'
      path: '/repeat-buyers'
      fullPath: '/repeat-buyers'
      preLoaderRoute: typeof AppRepeatBuyersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales': {
      id: '/_app/sales'
      path: '/sales'
      fullPath: '/sales'
      preLoaderRoute: typeof AppSalesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/search-console': {
      id: '/_app/search-console'
      path: '/search-console'
      fullPath: '/search-console'
      preLoaderRoute: typeof AppSearchConsoleRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/terms': {
      id: '/_app/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof AppTermsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/website': {
      id: '/_app/website'
      path: '/website'
      fullPath: '/website'
      preLoaderRoute: typeof AppWebsiteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meta/': {
      id: '/_app/meta/'
      path: '/meta'
      fullPath: '/meta/'
      preLoaderRoute: typeof AppMetaIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meta/ads': {
      id: '/_app/meta/ads'
      path: '/meta/ads'
      fullPath: '/meta/ads'
      preLoaderRoute: typeof AppMetaAdsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meta/audiences': {
      id: '/_app/meta/audiences'
      path: '/meta/audiences'
      fullPath: '/meta/audiences'
      preLoaderRoute: typeof AppMetaAudiencesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meta/campaigns': {
      id: '/_app/meta/campaigns'
      path: '/meta/campaigns'
      fullPath: '/meta/campaigns'
      preLoaderRoute: typeof AppMetaCampaignsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products/': {
      id: '/_app/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof AppProductsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products/$id': {
      id: '/_app/products/$id'
      path: '/products/$id'
      fullPath: '/products/$id'
      preLoaderRoute: typeof AppProductsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/shoppers/': {
      id: '/_app/shoppers/'
      path: '/shoppers'
      fullPath: '/shoppers/'
      preLoaderRoute: typeof AppShoppersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/shoppers/visitors': {
      id: '/_app/shoppers/visitors'
      path: '/shoppers/visitors'
      fullPath: '/shoppers/visitors'
      preLoaderRoute: typeof AppShoppersVisitorsRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRoute
  AppAuditRoute: typeof AppAuditRoute
  AppGoogleAdsRoute: typeof AppGoogleAdsRoute
  AppGoogleAdsResultsRoute: typeof AppGoogleAdsResultsRoute
  AppRepeatBuyersRoute: typeof AppRepeatBuyersRoute
  AppSalesRoute: typeof AppSalesRoute
  AppSearchConsoleRoute: typeof AppSearchConsoleRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppTermsRoute: typeof AppTermsRoute
  AppWebsiteRoute: typeof AppWebsiteRoute
  AppIndexRoute: typeof AppIndexRoute
  AppMetaAdsRoute: typeof AppMetaAdsRoute
  AppMetaAudiencesRoute: typeof AppMetaAudiencesRoute
  AppMetaCampaignsRoute: typeof AppMetaCampaignsRoute
  AppProductsIdRoute: typeof AppProductsIdRoute
  AppShoppersVisitorsRoute: typeof AppShoppersVisitorsRoute
  AppMetaIndexRoute: typeof AppMetaIndexRoute
  AppProductsIndexRoute: typeof AppProductsIndexRoute
  AppShoppersIndexRoute: typeof AppShoppersIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRoute,
  AppAuditRoute: AppAuditRoute,
  AppGoogleAdsRoute: AppGoogleAdsRoute,
  AppGoogleAdsResultsRoute: AppGoogleAdsResultsRoute,
  AppRepeatBuyersRoute: AppRepeatBuyersRoute,
  AppSalesRoute: AppSalesRoute,
  AppSearchConsoleRoute: AppSearchConsoleRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppTermsRoute: AppTermsRoute,
  AppWebsiteRoute: AppWebsiteRoute,
  AppIndexRoute: AppIndexRoute,
  AppMetaAdsRoute: AppMetaAdsRoute,
  AppMetaAudiencesRoute: AppMetaAudiencesRoute,
  AppMetaCampaignsRoute: AppMetaCampaignsRoute,
  AppProductsIdRoute: AppProductsIdRoute,
  AppShoppersVisitorsRoute: AppShoppersVisitorsRoute,
  AppMetaIndexRoute: AppMetaIndexRoute,
  AppProductsIndexRoute: AppProductsIndexRoute,
  AppShoppersIndexRoute: AppShoppersIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
